import { put, call, select } from 'redux-saga/effects';

import { get } from 'lodash';
import {
  SET_SERVER_ERROR,
  AUTH_REDIRECT_TO_LOG_IN,
} from '../store/actions/general';
import { MAX_REQUEST_TIME_BEFORE_ERROR } from '../consts/errors';
import { isAgentModeSelector } from '../store/selectors/appMode';

const fetch = async (url, data, token) => {
  let requestData;

  if (token === undefined) {
    requestData = data;
  } else {
    requestData = {
      credentials: 'include',
      ...data,
      headers: {
        Authorization: token,
        ...data.headers,
      },
    };
  }

  try {
    const response = await window.fetch(url, requestData);
    const responseData = await response.json();
    return { response, responseData };
  } catch (error) {
    return null;
  }
};

export default function* fetchData(url, { ...data } = {}, isNeedAuth = true) {
  const isAgentMode = yield select(isAgentModeSelector);
  let token;
  if (isNeedAuth) {
    token = yield select(({ general }) => general.token);
  }

  const timeBeforeLoad = performance.now();
  const res = yield call(fetch, url, data, token);
  const timeAfterLoad = performance.now();

  const loadTime = timeAfterLoad - timeBeforeLoad;
  const status = get(res, 'response.status');
  const statusText = get(res, 'response.statusText');
  const responseData = get(res, 'responseData');
  const success =
    get(responseData, 'success') ||
    get(responseData, 'meta.success') ||
    get(responseData, 'info.client') ||
    get(responseData, 'meta.total') ||
    get(responseData, 'access_url') ||
    !!get(responseData, 'token');
  const isExpectedUnauthorized = isAgentMode && status === 401;

  if (!success && !isExpectedUnauthorized) {
    yield put({
      error: {
        url,
        funcName: 'fetchData',
        text: statusText,
        data: responseData,
      },
      type: SET_SERVER_ERROR,
    });
  }

  if (status === 401 && !isAgentMode) {
    yield put({
      type: AUTH_REDIRECT_TO_LOG_IN,
    });
  }

  if (loadTime > MAX_REQUEST_TIME_BEFORE_ERROR) {
    yield put({
      error: {
        url,
        funcName: 'fetchData',
        loadTime,
      },
      type: SET_SERVER_ERROR,
    });
  }

  return responseData;
}
